module.exports = __webpack_public_path__ + "static/media/galeryAntihumidity6.d71c9af7.jpg";